import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

const AdminPasswordReset = () => {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [hasSession, setHasSession] = useState(false);
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        setHasSession(true);
        setReady(true);
      }
    });

    supabase.auth.getSession().then(({ data: { session } }) => {
      setHasSession(!!session);
      setReady(true);
    });

    return () => sub.subscription.unsubscribe();
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Das Passwort muss mindestens 8 Zeichen haben.");
      return;
    }
    if (password !== repeat) {
      toast.error("Die beiden Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) {
      toast.error(error.message);
      return;
    }
    toast.success("Neues Passwort gespeichert");
    navigate("/admin/blog");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary px-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="text-2xl font-bold text-foreground mb-2">Neues Passwort</h1>

        {!ready ? (
          <p className="text-sm text-muted-foreground">Einen Moment…</p>
        ) : !hasSession ? (
          <>
            <p className="text-sm text-muted-foreground mb-6">
              Dieser Link ist nicht mehr gültig. Bitte fordere auf der Anmeldeseite einen
              neuen Link an.
            </p>
            <Button className="w-full" onClick={() => navigate("/admin/login")}>
              Zur Anmeldung
            </Button>
          </>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mb-6">
              Bitte vergib ein neues Passwort für den Adminbereich.
            </p>
            <form onSubmit={onSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="pw">Neues Passwort</Label>
                <Input
                  id="pw"
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="pw2">Passwort wiederholen</Label>
                <Input
                  id="pw2"
                  type="password"
                  required
                  minLength={8}
                  value={repeat}
                  onChange={(e) => setRepeat(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <Button type="submit" className="w-full" disabled={loading}>
                {loading ? "Speichern…" : "Passwort speichern"}
              </Button>
            </form>
          </>
        )}
      </Card>
    </div>
  );
};

export default AdminPasswordReset;
